export const GET_ONE_DATA_LOADING = "GET_ONE_DATA_LOADING"; 
export const GET_ONE_DATA_SUCCESS = "GET_ONE_DATA_SUCCESS"; 
export const GET_ONE_DATA_ERROR = "GET_ONE_DATA_ERROR"; 